import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { useFeatureTogglesStore } from "../feature-toggles/featureTogglesStore";

const selfServicePolicyBannersFeatureToggleName = "enableSelfServicePolicyBanners";

export const useBannerStore = defineStore("Banners", () => {

    const { isFeatureToggleEnabled } = useFeatureTogglesStore();

    const isSelfServicePolicyBannersFeatureEnabled = ref<boolean>(false);

    const refreshFeatureToggles = async () => {
        isSelfServicePolicyBannersFeatureEnabled.value = await isFeatureToggleEnabled(selfServicePolicyBannersFeatureToggleName);
    };

    const initializeBannerStore = async () => {
        await refreshFeatureToggles();
    };

    initializeBannerStore();

    const showSelfServicePolicyBanners = computed(() => isSelfServicePolicyBannersFeatureEnabled.value);

    return {
        isSelfServicePolicyBannersFeatureEnabled,
        showSelfServicePolicyBanners,
    }
});